var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 76,
    viewBox: "0 0 98 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M8.70073 68.6505C3.03948 62.6514 0 55.9229 0 45.0159C0 25.8231 13.5045 8.62088 33.143 0.115723L38.0513 7.6722C19.7209 17.5647 16.1373 30.402 14.7082 38.4958C17.6598 36.9714 21.5237 36.4395 25.3107 36.7904C35.2261 37.7062 43.042 45.8275 43.042 55.9229C43.042 61.0132 41.0152 65.8949 37.4075 69.4943C33.7998 73.0936 28.9067 75.1157 23.8047 75.1157C17.9071 75.1157 12.2679 72.4287 8.70073 68.6505ZM63.6643 68.6505C58.003 62.6514 54.9635 55.9229 54.9635 45.0159C54.9635 25.8231 68.4681 8.62088 88.1066 0.115723L93.0148 7.6722C74.6845 17.5647 71.1008 30.402 69.6718 38.4958C72.6233 36.9714 76.4873 36.4395 80.2743 36.7904C90.1897 37.7062 98 45.8275 98 55.9229C98 61.0132 95.9732 65.8949 92.3655 69.4943C88.7579 73.0936 83.8648 75.1157 78.7628 75.1157C72.8652 75.1157 67.2259 72.4287 63.6588 68.6505H63.6643Z",
    fill: "#C5D4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.7fb594a77cfcdaa42740fe6b8743b40b.svg";
export { ForwardRef as ReactComponent };